import { createFileRoute } from '@tanstack/react-router'
import { DocumentUploadPage } from '@/features/documents/upload'

export const Route = createFileRoute('/documents_/upload')({
  component: DocumentUploadPage,
})
